import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-bottom-buttons",
  templateUrl: "./bottom-buttons.component.html",
})
export class BottomButtonsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
